export const GET_COUPONS_START = 'coupons/GET_COUPONS_START';
export const GET_COUPONS_FAILED = 'coupons/GET_COUPONS_FAILED';
export const GET_COUPONS_COMPLETED = 'coupons/GET_COUPONS_COMPLETED';

export const DELETE_COUPONS_COMPLETED = 'coupons/DELETE_COUPONS_COMPLETED';

export const FILTER_COUPONS_START = 'coupons/FILTER_COUPONS_START';
export const FILTER_COUPONS_COMPLETED = 'coupons/FILTER_COUPONS_COMPLETED';
export const FILTER_COUPONS_FAILED = 'coupons/FILTER_COUPONS_FAILED';
